import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DefinitionTreeNode from './../common/DynamicTree/DefinitionTreeNode';

export default class DefinitionTreeV2 extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedElementID: -1 };
  }

  onClick = selectedElement => {
    this.setState({ selectedElementID: selectedElement.definitionId });
    this.props.handleClick(selectedElement);
    const breadCrumbList = [];
    breadCrumbList.push(selectedElement.folderName);
    breadCrumbList.push('Definitions');
    window.localStorage.setItem('breadCrumb', JSON.stringify(breadCrumbList));
  };

  handleTreeDrop = (selectedEntries, selectedElement) => {
    this.setState({ selectedElementID: selectedElement.definitionId });
    this.props.handleTreeDrop(selectedEntries, selectedElement);
  };

  renderDefinitionItems = () =>
    this.props.definitionList.map(definition => (
      <div
        className={`definitions ${
          this.state.selectedElementID === definition.definitionId
            ? 'selected'
            : ''
          }`}
        key={definition.definitionId}
      >
        <DefinitionTreeNode
          definition={definition}
          handleClick={this.onClick}
          handleTreeDrop={this.handleTreeDrop}
        />
      </div>
    ));

  render() {
    const dictionaryHeight = this.props.noExpressionBox ? '51rem' : '25rem';
    return (
      <div className="dictionory-grid" style={{ height: dictionaryHeight }}>{this.renderDefinitionItems()}</div>
    );
  }
}

DefinitionTreeV2.propTypes = {
  definitionList: PropTypes.arrayOf(PropTypes.shape({})),
  handleClick: PropTypes.func,
  handleTreeDrop: PropTypes.func,
  noExpressionBox: PropTypes.bool,
};
